import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLocation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLocation"><Path fillRule="evenodd" clipRule="evenodd" d="M6.39159 6.39354L22.0903 1.9082L17.6049 17.6069L1.90625 22.0922L6.39159 6.39354ZM9.62327 12C9.62327 10.6883 10.6866 9.625 11.9983 9.625C13.3099 9.625 14.3733 10.6883 14.3733 12C14.3733 13.3117 13.3099 14.375 11.9983 14.375C10.6866 14.375 9.62327 13.3117 9.62327 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLocation;
